const state = {
  sentenceGroup: localStorage.getItem('sentenceGroup') ? JSON.parse(localStorage.getItem('sentenceGroup')) : ''
}

const mutations = {
  // reset all
  RESET_ALL(state, data) {
    const remove = ['sentenceModuleData']
    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        if (remove.indexOf(key) > -1) {
          state[key] = data
          localStorage.removeItem(key)
        }
      }
    }
  },
  // sentenceGroup
  SET_SENTENCE_GROUP(state, data) {
    state.sentenceGroup = data
    data === '' ? localStorage.removeItem('sentenceGroup') : localStorage.setItem('sentenceGroup', JSON.stringify(data))
  }
}

const actions = {
  // 清除所有信息
  resetAll({ commit }) {
    return new Promise(resolve => {
      commit('RESET_ALL', '')
      resolve()
    })
  },
  // 设置句子数据
  setSentenceGroup({ commit }, data) {
    commit('SET_SENTENCE_GROUP', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
